import { gql } from '@apollo/client';

export const GET_LINKED_GMAIL_DATA = gql`
# query GetGmailAuthData {
#   getGmailAuthData {
#   email
#   name  
#   }
# }

query GetGmailAuthData {
  getGmailAuthData {
    _id
    aliases {
      displayName
      isDefault
      sendAsEmail
    }
    email
    name
  }
}

`


export const GET_GMAIL_ALIAS = gql`
# query GetGmailAliases {
#   getGmailAliases {
#     sendAs {
#       displayName
#       isDefault
#       isPrimary
#       replyToAddress
#       sendAsEmail
#       signature
#     }
#   }
# }


query GetGmailAliases {
  getGmailAliases {
    displayName
    isDefault
    sendAsEmail
  }
}
`